import json from '#shared/util/json.js';
import logger from '#shared/util/logger.js';

import asyncCall from './asyncCall.js';
import avEvents from './avEvents.js';

/**
 * @typedef {object} LifAccountGetAccountInfo
 * @property {string} brand_id
 * @property {string} email
 * @property {string} first_name
 * @property {string} last_name
 * @property {boolean} logged_in
 * @property {string} shopper_id
 * @property {string} shopper_token
 * @property {string} username
 * @property {string} uuid
 * @property {boolean} verified
 * @property {object} [tickets]
 * @property {string} tickets.DEVT
 * @property {string} tickets.SHOP
 */

/**
 * Get account information from client (application)
 * @returns {Promise<LifAccountGetAccountInfo>}
 */
export default function getAccountFromClient() {
	const appCall = 'app.lif.account.get_account_info';
	return new Promise((resolve) => {
		const handleResponse = (response) => {
			const responseString = response || '{}';
			const responseObject = json.parse(responseString) || {};
			resolve(responseObject);
		};
		avEvents.addEventListener(appCall, (event, response) => {
			// (Mac) Response is returned from avEvents
			handleResponse(response);
		});
		asyncCall(appCall, ([response, error]) => {
			if (error) {
				logger.warn({
					code: 'CLIENT',
					origin: appCall,
					detail: json.parse(error) || {}
				});
				// Error will resolve into empty object '{}'
				handleResponse();
			}
			if (response) {
				// (Windows) Response is returned in callback
				handleResponse(response);
			}
		});
	});
}
